import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// PageHeader (fase 3, §26) — vários módulos (Financeiro é o caso mais
// visível) não tinham NENHUM título de página própria, só o breadcrumb
// pequeno e secundário da Topbar — o usuário caía direto nas tabs/tabela
// sem contexto. Padrão comum a Attio/Linear/Stripe: título forte +
// subtítulo opcional + ações primárias alinhadas à direita.
export function PageHeader({ icon, title, subtitle, actions }) {
  return (
    <div className="crm-page-header">
      <div className="crm-page-header-title-row">
        {icon && <span className="crm-page-header-icon"><FontAwesomeIcon icon={icon} /></span>}
        <div>
          <h1 className="crm-page-header-title">{title}</h1>
          {subtitle && <p className="crm-page-header-subtitle">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="crm-page-header-actions">{actions}</div>}
    </div>
  );
}

export default PageHeader;
